import React from 'react';
import usePartners from './usePartners';

export default function useInactivePartners(network, schoolStart, schoolEnd, currentTimestamp) {
  return usePartners(network, schoolStart, schoolEnd, {
    inactive: true
  });
}
